import { useEffect } from "react";
import { useGetAllProductsSubscriptionsQuery, useProductSubscriptionsStore } from "../providers/products";
import { useAuth } from "../contexts/auth-context";
import { useConfig } from "../providers/config";

const useInitializeProductSubscriptions = () => {
  const { user } = useAuth();
  const config = useConfig();
  const { addProductSubscription, productSubscriptionIdsMap } = useProductSubscriptionsStore.getState();

  const enabled = !!user?.id && config.isProductSubscriptionsEnabled;

  const { data: fetchedSubscriptions, isInitialLoading } = useGetAllProductsSubscriptionsQuery({
    enabled,
  });

  useEffect(() => {
    if (!isInitialLoading && enabled) {
      fetchedSubscriptions?.forEach((subscription) => {
        const alreadyAdded = productSubscriptionIdsMap[subscription.productId.id];

        if (!alreadyAdded) {
          addProductSubscription(subscription.productId);
        }
      });
    }
  }, [isInitialLoading]);
};

export default useInitializeProductSubscriptions;
